<template>
    <el-card class="stats-container">
        <div class="stats">
            <div class="stats-iconfont flex items-center">
                <el-tooltip
                    v-if="['statsFlow', 'revenueDaily'].includes(activeName)"
                    effect="dark" style="margin: 0 4px;"
                    :content="$t('Stats.Updatereport')"
                    placement="bottom">
                    <div class="iconfont icon-fitness-gengxin cursor-pointer" @click="handleUpdate()"></div>
                </el-tooltip>
                <el-tooltip
                    v-if="activeName === 'incomeFlow'"
                    effect="dark"
                    style="margin: 0 4px;"
                    :content="$t('Member.revenueflow.balancing')"
                    placement="bottom" >
                    <div
                        @click="handleFlat()"
                        class="iconfont icon-fitness-jisuanqi cursor-pointer">
                    </div>
                </el-tooltip>
                <el-tooltip
                    v-if="['incomeFlow', 'trainerCourse', 'groupsCourse'].includes(activeName)"
                    effect="dark"
                    :content="$t('tooltip.export')"
                    placement="bottom" >
                    <div
                        @click="handleExport()"
                        class="iconfont icon-fitness-daochu cursor-pointer">
                    </div>
                </el-tooltip>
            </div>
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane
                    v-if="$$filterPermission('统计-客流报表-客流报表查看和下载')"
                    :label="$t('Board.Flow.title')"
                    name="statsFlow"
                    :lazy="true"
                    v-once>
                    <stats-flow />
                </el-tab-pane>
                <el-tab-pane
                    v-if="$$filterPermission('统计-会员概况-查看会员概况')"
                    :label="$t('Stats.Member_profile')"
                    name="memberProfile"
                    :lazy="true"
                    v-once>
                    <member-profile />
                </el-tab-pane>
                <el-tab-pane
                    v-if="$$filterPermission('统计-营收日报-营收日报查看和下载')"
                    :label="$t('Stats.Revenue_daily')"
                    name="revenueDaily"
                    :lazy="true"
                    v-once>
                    <revenue-daily />
                </el-tab-pane>
                <el-tab-pane
                    v-if="$$filterPermission('统计-营收流水-营收流水的查看和下载')"
                    :label="$t('Stats.Revenue_streams')"
                    name='incomeFlow'
                    :lazy="true"
                    v-once>
                    <income-flow @handleForm="handleForm" ref="income_flow" />
                </el-tab-pane>
                <el-tab-pane
                    v-if="$$filterPermission('统计-私教上课-查看全部私教上课')
                    || $$filterPermission('统计-私教上课-仅查看自己上课')"
                    :label="$t('Stats.Enter.person_lesson')"
                    name='trainerCourse'
                    :lazy="true"
                    v-once>
                    <trainer-course @handleForm="handleForm" />
                </el-tab-pane>
                <el-tab-pane
                    v-if="$$filterPermission('统计-团课上课(统计)-查看团课上课(统计)')"
                    :label="$t('Stats.Enter.team_lesson')"
                    name='groupsCourse'
                    :lazy="true"
                    v-once>
                    <groups-course ref="group" @handleForm="handleForm" />
                </el-tab-pane>
            </el-tabs>
        </div>
        <update-report ref="update_report"/>
        <flat-account ref="flat_account" @fetchData="fetchData" />
    </el-card>
</template>
<script>
import { Tabs, TabPane } from 'element-ui';
import StatsFlow from '@/components/widget/Stats/Flow';
import IncomeFlow from '@/components/widget/Stats/IncomeFlow';
import TrainerCourse from '@/components/widget/Stats/TrainerCourse';
import GroupsCourse from '@/components/widget/Stats/GroupsCourse';
import RevenueDaily from '@/components/widget/Stats/RevenueDaily';
import MemberProfile from '@/components/widget/Stats/MemberProfile';
import UpdateReport from '@/components/Dialog/Stats/UpdateReport';
import FlatAccount from '@/components/Dialog/Stats/FlatAccount';

export default {
    components: {
        ElTabs: Tabs,
        ElTabPane: TabPane,
        StatsFlow,
        IncomeFlow,
        TrainerCourse,
        GroupsCourse,
        RevenueDaily,
        MemberProfile,
        UpdateReport,
        FlatAccount,
    },
    mixins: [require('../../mixins/CacheQuery').default],
    data() {
        return {
            url: null,
            form: null,
            editableTabs: [
                {
                    name: 'statsFlow',
                    isShow: this.$$filterPermission('统计-客流报表-客流报表查看和下载'),
                }, {
                    name: 'memberProfile',
                    isShow: this.$$filterPermission('统计-会员概况-查看会员概况'),
                }, {
                    name: 'revenueDaily',
                    isShow: this.$$filterPermission('统计-营收日报-营收日报查看和下载'),
                }, {
                    name: 'incomeFlow',
                    isShow: this.$$filterPermission('统计-营收流水-营收流水的查看和下载'),
                }, {
                    name: 'trainerCourse',
                    isShow: this.$$filterPermission('统计-私教上课-查看全部私教上课')
                    || this.$$filterPermission('统计-私教上课-仅查看自己上课'),
                }, {
                    name: 'groupsCourse',
                    isShow: this.$$filterPermission('统计-团课上课(统计)-查看团课上课(统计)'),
                },
            ],
        };
    },
    methods: {
        handleClick(tab, event) {
            if (tab.name === 'groupsCourse') this.$refs.group.handleReset();
        },
        handleUpdate() {
            const types = new Map([
                ['statsFlow', {id: 1, title: '客流'}],
                ['revenueDaily', {id: 2, title: '营收日报'}]
            ]);
            const type = types.get(this.activeName);
            this.$refs.update_report.open({
                type: type.id
            }, type.title);
        },
        handleFlat() {
            if (this.$$filterPermission('统计-收银流水-平账'))
                this.$refs.flat_account.open();
            else {
                $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                    confirmButtonText: this.$t('Message.confirm'),
                    callback: action => {},
                });
            }
        },
        handleExport() {
            if (this.activeName === 'incomeFlow') this.url = 'statistic/revenue/record/export';
            else if (this.activeName === 'trainerCourse') this.url = 'statistic/coach-schedule/export';
            else if (this.activeName === 'groupsCourse') this.url = 'statistic/team-schedule/export';
            let param = '';
            for (let prop in this.form) {
                if (this.form[prop]) param = `${param}&${prop}=${this.form[prop]}`;
            }
            param = param.replace('&', '?');
            const baseUrl = window.API.base_url;
            window.location.href = `${baseUrl}/${this.url}${param}`;
        },
        handleForm(val) {
            this.form = val;
        },
        // 营收流水平账刷新数据
        fetchData() {
            this.$refs.income_flow.fetchData();
        },
    }
};
</script>
<style lang="scss">
.stats-container {
    .el-tabs__header {
        position: static;
    }
}
.stats-iconfont {
    transition: transform .3s,-webkit-transform .3s;
    float: right;
    right: 0;
    top: 0;
    z-index: 2;
    padding: 0;
    margin: 22px 0 0 10px;
    color: #697a8e;
}
.icon-list {
    font-size: 15px;
    line-height: 40px;
    color: #697a8e;
    margin-left: 15px;
}
.top-select-time {
    font-size: 12px;
}
.stats-top-select {
    padding-top: 10px
}
.stats-table-cart {
    width: 100%;
    border: 1px solid #e6e4e4;
    padding: 25px 0;
    margin: 15px 0;
}
.table-cart-items {
    text-align: center;
    width: 25%;
}
.table-cart-items:not(:last-child) {
    border-right: 1px solid #e2e2e2;

}
.table-cart-title {
    color: #444;
    font-size: 16px;
}
.table-cart-num {
    font-size: 30px;
    color: #05abef;
    line-height: 45px;
}
.table-cart-small {
    font-size: 12px;
    color: #444;
    line-height: 25px;
}
.chart-show {
    height: 100px;
}
.table-cart-small {
    font-size: 16px;
    color: #444;
    line-height: 25px;
}
</style>
